export default __webpack_public_path__ + "img/forbes.8c8a008f.svg";